import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/ui/dropdown";
import { SubscriptionOfferStatus } from "@/gql/__generated__/graphql";
import { Ellipsis } from "lucide-react";
import { useSubscriptionOfferWithdraw } from "../../hooks/subscriptionOfferWithdraw";

function SubscriptionOfferActions({
  offer
}: {
  offer: {
    id: string;
    status: SubscriptionOfferStatus;
  };
}) {
  const { handleSubscriptionOfferWithdraw } = useSubscriptionOfferWithdraw(
    offer.id
  );

  let options: JSX.Element[] = [];
  if (offer.status === SubscriptionOfferStatus.Pending) {
    options = [
      ...options,
      <DropdownMenuItem
        className="text-brand-error"
        key="option-withdraw-offer"
        onClick={handleSubscriptionOfferWithdraw}
      >
        Withdraw offer
      </DropdownMenuItem>
    ];
  }

  if (options.length === 0) return null;
  return (
    <div className="flex justify-end pr-2">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="h-8 w-8 p-0">
            <span className="sr-only">Open menu</span>
            <Ellipsis className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">{options}</DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}

export default SubscriptionOfferActions;
